import { Id } from '@/infra/id'
import { Model, type ModelProps } from '@/infra/model'
import { unixEpoch } from '@/utils/date-util'
import { computed, observable } from 'mobx'
import { BillingProfile } from '@/features/billing/profile/BillingProfile'
import { once } from 'lodash-es'

export type BillingMethodProps = ModelProps<BillingMethod>

export type BillingMethodType = StripeCardMethod | CreditMethod | UnknownMethod

export interface StripeMethod {
  readonly type: 'Stripe'
  readonly expMonth: number
  readonly expYear: number
  readonly brand: string
  readonly last4: string
}

export interface StripeCardPaymentMethod {
  readonly type: 'StripeCardPaymentMethod'
  readonly expMonth: number
  readonly expYear: number
  readonly brand: string
  readonly last4: string
}

export type StripeCardMethod = StripeMethod | StripeCardPaymentMethod

export interface CreditMethod {
  readonly type: 'Credit'
  readonly balance: number
  readonly limit: number
}

export interface UnknownMethod {
  readonly type: 'Unknown'
}

export class BillingMethod extends Model<BillingMethod> {
  id = Id.none

  @observable accessor type: BillingMethodType = { type: 'Unknown' }
  @observable accessor dateCreated = unixEpoch()

  constructor(public readonly profile: BillingProfile) {
    super()
  }

  /**
   * Default instance.
   */
  static get none() {
    return lazyNone()
  }

  @computed
  get isDefault() {
    return this.profile.defaultBillingMethodId === this.id
  }
}

const lazyNone = once(() => new BillingMethod(BillingProfile.none))
